var React = require('react');

function X2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"12","cy":"12","r":"12","fill":"#EAF7FF","key":0}),React.createElement("path",{"fill":"#3899EC","d":"M15.92 8.727L15.2 8 12 11.232 8.8 8l-.72.727 3.2 3.233L8 15.273l.72.727L12 12.687 15.28 16l.72-.727-3.28-3.313z","key":1})]));
}

X2.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = X2;

X2.default = X2;
